module.exports = __webpack_public_path__ + "static/media/Assigned-in-UAE.17cbc805.jpg";